import React, { use } from 'react';
import Select from 'react-select';
import { UserStatusDropdownOptions } from '../../../utils/constant';
import { customStyles, customTheme } from './UserStatusDropDownStyles';
import { updateUsersCompanyStatus } from '../../../api/user-setting';
import toast from 'react-hot-toast';

export default function UserStatusDropDown({ status, userId }) {
  const handelStatusChange = async (e) => {
    try {
      const updateStatusResponse = await updateUsersCompanyStatus(userId, e.value);
      toast.success(updateStatusResponse?.data?.message)
    } catch (e) {
      toast.error(e?.response?.data?.error);
    }
  };

  return (
    <div className="relative">
      <Select
        theme={customTheme}
        styles={customStyles}
        defaultValue={UserStatusDropdownOptions.find((option) => option.value === status)}
        options={UserStatusDropdownOptions}
        getOptionLabel={(e) => <div style={{ color: e.color }}>&#x2022; {e.label}</div>}
        menuPortalTarget={document.body}
        isSearchable={false}
        onChange={handelStatusChange}
        components={{
          IndicatorSeparator: () => null,
          IndicatorsContainer: () => null
        }}
      />
    </div>
  );
}
